function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) { return null; }
    if (!results[2]) { return ''; }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

let activeGroup = getParameterByName('groupID'),
    activeBrand = getParameterByName('brandID'),
    activeProduct = getParameterByName('productID'),
    activeProductHash = '';

// Force scroll to top
if (location.hash) {
    window.scrollTo(0, 0);
    setTimeout(function() {
        window.scrollTo(0, 0);
    }, 1);
}

jQuery(document).ready(function ($) {
    // Mobile menu
    let trigger = $('.menutoggle');
    let isClosed = false;

    trigger.click(function () {
        toggleMenu();
    });
    function toggleMenu() {
        let HTML = $('HTML');
        if (isClosed) {
            if (HTML.hasClass('menu-open')) {
                HTML.removeClass('menu-open');
            }
            trigger.removeClass('is-open');
            trigger.addClass('is-closed');
            isClosed = false;
        } else {
            HTML.addClass('menu-open');
            trigger.removeClass('is-closed');
            trigger.addClass('is-open');
            isClosed = true;
        }
    }
    const $menu = $('#primary-menu');
    $menu.find('.menu-item-has-children').each(function(){
        const $el = $(this);
        const $btnExpand = $('<button class="menu-expander">'+labels.btnExpand+'</button>');
        $btnExpand
            .insertBefore($('> ul',$el))
            .click(function(){
                $el.addClass('expanded');
                $el.parent().addClass('has-submenu-expanded');
            })
        ;
        $('> UL', $el).wrap('<div class="submenu-wrapper"/>');
        const $btnBack = $('<button class="menu-collapser">'+labels.btnBack+'</button>');
        $btnBack
            .prependTo($('.submenu-wrapper',$el))
            .click(function(){
                $el.removeClass('expanded');
                $el.parent().removeClass('has-submenu-expanded');
            })
        ;
    });

    $menu.find('A[href="#"]').click(function(e) { e.preventDefault(); });

    // Hide Header on scroll down
    let didScroll;

    function fadeSection() {
        $('SECTION, FOOTER').each(function() {
            const top_of_object = $(this).position().top;
            const bottom_of_window = $(window).scrollTop() + $(window).height();
            if( bottom_of_window > top_of_object ){
                if( ! $(this).hasClass('section-animate') ) {
                    $(this).addClass('section-animate');
                }
            }
        });
    }
    fadeSection();

    // Sections fade in + sticky
    $(window).scroll(function() {
        fadeSection();
        didScroll = true;
    });

    // Tabs
    var hash = document.location.hash.substring(1, document.location.hash.length),
        scrolltop;
    $('.tabs__content').each(function () {
        if (!$(this).attr('id')) {
            $(this).addClass('active');
        }
    });
    $('[data-tabs="true"]').each(function () {
        var isActive = false;
        if ($(this).find('A[rel="' + hash + '"]').length > 0) {
            isActive = true;
        }

        const $tablist = $(this);
        $tablist
            .attr('role', 'tablist')
            .on('click', 'A', function (e) {
                var panelID = $(this).attr('href').substring($(this).attr('href').indexOf('#'));
                if ($(panelID).length !== 0) {
                    e.preventDefault();
                    scrolltop = $(window).scrollTop();
                    var currentlyActive = false;
                    if ($(this).hasClass('active')) {
                        currentlyActive = true;
                    }
                    $(this).closest('.tabs').removeClass('open').find('.tabs__item').each(function(){
                        $(this).attr('aria-selected', 'false');
                        $('A',this).removeClass('active');
                        var pID = $('A',this).attr('href').substring($('A',this).attr('href').indexOf('#'));
                        var $panel = $(pID);
                        $panel.removeClass('active').attr('aria-expanded', 'false').attr('aria-hidden', 'true');
                        $(pID + ' .news01').removeAttr('id');
                    });

                    var $panel = $(panelID);
                    $panel
                        .addClass('active')
                        .attr('aria-expanded', 'true')
                        .attr('aria-hidden', 'false')
                        .children('.tab-panel-heading')/*.attr("tabindex", -1)*/.focus()
                        .next().attr('id', 'response');

                    $(this).addClass('active').closest('.tabs__item').addClass('active').attr('aria-selected', 'true');

                    if ($(this).attr('rel')) {
                        document.location.hash = $(this).attr('rel');
                    }
                    $(window).scrollTop(scrolltop);
                    $(window).resize();
                }
                return false;
            })
            .delegate('a', 'keydown',
                function (e) {
                    const tab = $(this);
                    switch (e.which) {
                        case 13:
                            e.preventDefault();
                            tab.click();
                            break;
                    }
                }
            )
            .find('.tabs__item').attr('role', 'tab')
            .find('A').each(function () {
                var ariaid = 'ui-' + new Date().getMilliseconds() + Math.random().toString(36).substr(2, 5),
                    t = $(this),
                    str = t.attr('href').substring(t.attr('href').indexOf('#')),
                    rel = t.attr('rel'),
                    $li = t.closest('.tabs__item');
                if (rel === 'undefined') {
                    rel = '';
                }

                if (str.indexOf('#') !== -1) {
                    if ($(str).length !== 0) {
                        $(str).css('display', '').addClass('initialized');
                        if (hash.length > 0) {
                            if (hash === rel) {
                                t.addClass('active').closest('.tabs__item').addClass('active');
                            } else {
                                if (isActive === true) {
                                    t.removeClass('active').closest('.tabs__item').removeClass('active');
                                }
                            }
                        }
                        if (t.hasClass('active')) {
                            $li.addClass('active');
                        }
                        if ($li.hasClass('active')) {
                            $li.attr('aria-selected', 'true');
                            $(str).addClass('active').attr('role', 'tabpanel').attr('aria-labelledby', ariaid).attr('aria-expanded', 'true').attr('aria-hidden', 'false');
                        } else {
                            $li.attr('aria-selected', 'false');
                            $(str).removeClass('active').attr('role', 'tabpanel').attr('aria-labelledby', ariaid).attr('aria-expanded', 'false').attr('aria-hidden', 'true');
                        }
                        t.attr('id', ariaid).attr('role', 'presentation');
                        $li
                            .attr('aria-labelledby', ariaid)
                            .attr('aria-controls', t.attr('href').substring(t.attr('href').indexOf('#') + 1));
                    }
                }
                $(this).on('keydown', function (e) {
                        const tab = $(this);
                        switch (e.which) {
                            case 37: case 38:
                                e.preventDefault();

                                if (tab.parent().prev().length!=0) {
                                    tab.parent().prev().find('> a').click();
                                } else {
                                    $tablist.find('.tabs__item:last > a').click();
                                }
                                break;
                            case 39: case 40:
                                e.preventDefault();

                                if (tab.parent().next().length!=0) {
                                    tab.parent().next().find('> a').click();
                                } else {
                                    $tablist.find('.tabs__item:first > a').click();
                                }
                                break;
                        }
                    }
                );
            }
        )
            .end();
        $tablist.addClass('initialized');
    });

    // Country select
    $('.country-select__toggle').click(function(){
        $('.country-select').toggleClass('open');
    });

    // Pattern parallax

    const $section = $('.page-content');
    if($section.length>0) {
        const scrollheight = $section.height();
        const offset = $section.offset().top;
        const incrementSize = scrollheight / 6;
        $(window).scroll(function () {
            const pos = $(window).scrollTop();
            if (pos > 10) {
                $('html').addClass('scroll');
            } else {
                $('html').removeClass('scroll');
            }
            if (pos > offset) {
                const revealSize = Math.ceil((pos - offset) / incrementSize);
                $('.pattern').attr('data-reveal', revealSize);
            } else {
                $('.pattern').attr('data-reveal', 0);
            }
        });

        $(window).scroll();
    }

    // Content sliders
    let $contentwrapper = $('.product-items__content');
    let lastProductFilter = '';

    $('.content-slider').each(function () {
        const settings = {
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            dots: false,
            adaptiveHeight: true,
        };
        const type = $(this).data('type');
        if (type === 'news') {
            settings.slidesToShow = 2;
            settings.slidesToScroll = 2;
            settings.centerMode = false;
            settings.infinite = false;
            settings.arrows = true;
            settings.variableWidth = false;
            settings.responsive = [
                {
                    breakpoint: 1200,
                    settings: {
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 759,
                    settings: {
                        infinite: true,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 550,
                    settings: {
                        infinite: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ];
        }
        $(this).slick(settings);

        var oldReinit = $(this).slick('getSlick').reinit;
        var newReinit = function reinitOverride(){
            this._overriddenReinit();
            this.$slides.each(function(index, element) { $(element).attr('data-slick-index', index); });
        };
        $(this).slick('getSlick')._overriddenReinit = oldReinit;
        $(this).slick('getSlick').reinit = newReinit;
    });

    let $brands = $('.product-brands .portfolio-slider'),
        brandsinstance,
        $products = $('.product-items .portfolio-slider'),
        productsinstance;
    $('.product-groups LI').each(function() {
        let hoverOutTimeout, hoverInTimeout;
        const $li = $(this);
        $(this)
            .mouseenter(function(e){
                clearTimeout(hoverOutTimeout);
                if ($li.hasClass('has-sub')) {
                    hoverInTimeout = setTimeout(function() {
                        e.preventDefault();
                        $li.addClass('open');
                        $li.siblings().removeClass('open').find('LI').removeClass('open');

                    }, 200);
                }
            })
            .mouseleave(function(e){
                if ($li.hasClass('has-sub')) {
                    clearTimeout(hoverInTimeout);
                    clearTimeout(hoverOutTimeout);
                    hoverOutTimeout = setTimeout(function() {
                        e.preventDefault();
                        $li.removeClass('open');

                    }, 500);
                }
            });
        $('> A', this)
            .click(function(e){
                e.preventDefault();
                const isMobile = $('.menutoggle').css('fontFamily');
                if(isMobile){
                    if($(this).parent().hasClass('open') || !$(this).parent().hasClass('has-sub')){
                        selectProductGroup($(this))
                    } else {
                        $(this).parent().addClass('open');
                    }
                } else {
                    selectProductGroup($(this));
                }
            });

        if ($('UL', this).length > 0) {
            $(this).addClass('has-sub');
        }
        if ($('LI.active', this).length > 0) {
            $(this).addClass('active');
        }
    });

    function selectProductGroup($el) {
        $('.product-groups LI').removeClass('active');
        $el.parent().addClass('active');
        const groups = [];
        $el.parentsUntil( '.product-groups', 'LI' ).each(function(){
            $(this).addClass('active');
            $(this).removeClass('open');
        });
        $el.parent().find('A').each(function(){
            groups.push('[data-group~="'+$(this).data('group')+'"]');
        });
        const group = $el.data('group');
        activeGroup = group;

        if(typeof(brandsinstance) === 'undefined') {
            $('.product-brands .portfolio-slider').slider({
                afterChange: function(el){
                    const brand = $(el).data('brand');
                    activeBrand = brand;
                    const productgroups = [];
                    const activeProductGroup = $('.product-groups A[data-group="'+ activeGroup +'"]');
                    if (activeProductGroup && activeGroup!==null) {
                        activeProductGroup.parent().find('A').each(function(){
                            productgroups.push('[data-brand="'+brand+'"][data-group~="'+$(this).data('group')+'"]');
                        });
                    } else {
                        productgroups.push('[data-brand="'+brand+'"]');
                    }
                    $products.css('opacity',0);
                    if(typeof(productinstance)==='undefined'){
                        $('.product-items').append('<div id="product-content" class="product-items__content"></div>');
                        $('.product-items .portfolio-slider').slider({
                            afterChange: function($el) {
                                $products.animate({opacity:1},300);
                                $('#product-content').html($('.product-items__content', $el).html())
                                activeProduct = $el.data('id');
                                activeProductHash = $el.find('A').attr('id');
                                updateUrl();
                            },
                            initialFilter: productgroups.join(','),
                            initialSlide: activeProduct!==null ? '[data-id="'+activeProduct+'"]' : '',
                        });
                        productinstance = $products.data('slider');
                    } else {
                        productinstance.filter(productgroups.join(','), false, '[data-id="'+activeProduct+'"]');
                    }
                },
                initialFilter: groups.join(','),
                initialSlide: activeBrand!==null ? '[data-brand="'+activeBrand+'"]' : '',
            });
            brandsinstance = $brands.data('slider')
            $('.slide A', $brands).click(function(e) {
                e.preventDefault();
                brandsinstance.goTo('[data-brand="'+$(this).closest('.slide').data('brand')+'"]')
            })
        } else {
            brandsinstance.filter(groups.join(','));
        }
    }

    if(typeof activeGroup !== 'undefined'){
        if (activeGroup===null) {
            selectProductGroup($('.product-groups > UL > LI:first-child > A'));
        } else {
            selectProductGroup($('.product-groups > UL A[data-group="'+activeGroup+'"]'));
        }
    }

    function updateUrl() {
        const currentURL = window.location.protocol + '//' + window.location.host + window.location.pathname + '?groupID=' + activeGroup + '&brandID=' + activeBrand + '&productID=' + activeProduct + '#' + activeProductHash;
        window.history.pushState({ path: currentURL }, '', currentURL);
        return false;
    }

    if (typeof availableBrands !== 'undefined') {
        $('#brand_input').autocomplete({
            minLength: 0,
            appendTo: '#brands_search',
            source: availableBrands,
            focus: function( event, ui ) {
                $('#brand_input').val( ui.item.label );
                return false;
            },
            select: function( event, ui ) {
                $('#brand_input').val( ui.item.label );
                $('#brandID').val( ui.item.value );
                selectFoundBrand(ui.item);
                return false;
            }
        })
            .data('ui-autocomplete')._renderItem = function( ul, item ) {
            let txt = String(item.label).replace(new RegExp(this.term, 'gi'),'<b>$&</b>');
            return $('<li></li>')
                .data('ui-autocomplete-item', item)
                .append('<div>' + txt + '</div>')
                .appendTo(ul);
        };

        $('#brands_search').submit(function(e) {
            e.preventDefault();
            const $input = $('#brand_input');
            const str = $input.val();
            $input.autocomplete('close');
            const result = availableBrands.filter(obj => {
                return obj.label.toLowerCase() === str.toLowerCase();
            });
            if (result.length>0){
                const brand = result[0];
                selectFoundBrand(brand);
            }

        });
    }

    const selectFoundBrand = function(brand) {
        activeBrand = brand.value;
        const tmpBrand = activeBrand;
        activeGroup = brand.groups.split(' ')[0];
        if (tmpBrand !== null) {
            brandsinstance.filter('[data-brand="' + tmpBrand + '"]');
        }
    };
});

(function($){
    $.slider = function(el, options){
        const base = this;
        base.$el = $(el);

        base.el = el;
        base.$el.data('slider', base);
        base.$slides = $('.slides', base.$el);
        base.slideWidth = 0;
        base.$slideItems = $('.slide', base.$el);
        base.perPage = parseInt(base.$el.data('per-page'));
        base.paddingLeft = (base.perPage-1)/2-1;
        base.paddingRight = (base.perPage-1)/2;

        base.updateScroll = function() {
            base.$slideItems.removeClass('current');
            base.$currentSlide.addClass('current');
            const $visibleSlides = $('.slide', base.$el).filter(':visible');
            let offset = (base.$currentSlide.position().left*-1)+base.slideWidth*base.paddingRight;
            const index = $visibleSlides.index(base.$currentSlide);
            if($visibleSlides.length>=base.perPage) {
                $('button', base.$el).show();
                if (index <= base.paddingLeft){
                    const $visible = $('.slide:visible', base.$el).slice(-base.paddingRight);
                    const $invisible = $visible.last().nextAll();
                    const $invisible2 = $visible.prevUntil(':visible').not(':visible');
                    $invisible.detach().prependTo(base.$slides);
                    $visible.detach().prependTo(base.$slides);
                    $invisible2.detach().prependTo(base.$slides);
                    base.$slides.css('left',-base.$currentSlide.position().left+base.slideWidth*(base.paddingRight-1))
                    offset = (base.$currentSlide.position().left-base.slideWidth*base.paddingRight)*-1;
                }
                else if (index >= $visibleSlides.length-base.paddingRight){
                    const $visible = $('.slide:visible', base.$el).slice(0,base.paddingRight);
                    const $invisible = $visible.first().prevAll();
                    const $invisible2 = $visible.nextUntil(':visible').not(':visible');
                    $invisible.detach().appendTo(base.$slides);
                    $visible.detach().appendTo(base.$slides);
                    $invisible2.detach().appendTo(base.$slides);
                    base.$slides.css('left',-(base.$currentSlide.position().left-base.slideWidth*(base.paddingRight+1)))
                    offset = (base.$currentSlide.position().left-base.slideWidth*base.paddingRight)*-1;
                }
            } else {
                $('button', base.$el).css('display','block');
                if (index <= base.paddingLeft) {
                    $('.slider__control-prev', base.$el).css('display','none');
                } else if (index >= $visibleSlides.length-base.paddingRight) {
                    $('.slider__control-next', base.$el).css('display','none');
                }
            }
            base.$slides.animate({
                left: offset+'px',
            }, 500, function() {
                $('button', base.$el).attr('disabled',false);
                base.options.afterChange(base.$currentSlide);
            });
            $('button', base.$el).attr('disabled',true);
        }

        base.init = function(){
            $(window).resize(function(){
                base.slideWidth = base.$currentSlide.outerWidth();
                base.updateScroll();
            })
            base.options = $.extend({},$.slider.defaultOptions, options);

            $('.slider__control-next', base.$el).click(function(){
                const $slide = base.$currentSlide.nextAll(':visible').first();
                if($slide.length>0) {
                    base.$currentSlide = $slide;
                    base.updateScroll();
                }
            });
            $('.slider__control-prev', base.$el).click(function(){
                const $slide = base.$currentSlide.prevAll(':visible').first();
                if($slide.length>0) {
                    base.$currentSlide = $slide;
                    base.updateScroll();
                }
            });
            if (base.options.initialFilter!=='') {
                base.filter(base.options.initialFilter, true)
            }
            if(base.options.initialSlide!== '' && typeof(base.options.initialSlide)!=='undefined') {
                base.$currentSlide = $('.slide:visible', base.$el).filter(base.options.initialSlide)
            } else {
                base.$currentSlide = $('.slide:visible', base.$el).first();
            }
            $(window).resize();
        };

        base.filter = function(selector, filterOnly, activeSlideSelector){
            const $filtered = base.$slideItems.filter(selector);
            base.$slideItems.css('display','none');
            $filtered.css('display','block');
            if(!filterOnly) {
                if (activeSlideSelector) {
                    base.$currentSlide = $filtered.filter(activeSlideSelector);
                    if (base.$currentSlide.length === 0) {
                        base.$currentSlide = $filtered.first();
                    }
                } else {
                    base.$currentSlide = $filtered.first();
                }
                base.updateScroll();
            }
            base.$visibleSlides = $('.slide', base.$el).filter(':visible');
        };
        base.goTo = function(selector){
            base.$currentSlide = base.$slideItems.filter(selector);
            base.updateScroll();
        };
        base.init();
    };

    $.slider.defaultOptions = {
        initialFilter: '',
        initialSlide: '',
        afterChange: function(el) { return; }
    };

    $.fn.slider = function(options){
        return this.each(function(){
            (new $.slider(this, options));
        });
    };

})(jQuery);
